<template>
  <div>
    <b-modal ref="createLotModal"
             :title="title" :no-close-on-backdrop="true">
      <b-row>
        <b-col cols="2">
          <label>{{isExchangeContract ? $t('labels.lots.lot_number') :
            $t('labels.lots.spec_number')}}</label>
        </b-col>
        <b-col cols="4">
          <input class="form-control" v-model="lotData.lot_nr" tabindex="1"
                 :class="{ required: (!lotData.lot_nr) }"
                 :disabled="!isActiveLot"
                 placeholder="Enter lot number">
        </b-col>
        <b-col cols="2">
          <label>{{$t('labels.common.pricePerm3')}}</label>
        </b-col>
        <b-col cols="2">
          <input class="form-control" v-model="lotData.price_per_unit" :tabindex="12"
                 placeholder="price"
                 :disabled="!isActiveLot"
                 :class="{ required: (!lotData.price_per_unit) }"
                 v-digits-after-decimal="{numberOfDigits: 2}">
        </b-col>
        <b-col cols="2">
          <input class="form-control" v-model="lotData.currency" :disabled="true">
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="2">
          <label>{{$t('labels.common.wood')}}</label>
        </b-col>
        <b-col cols="4">
          <multiselect v-model="lotData.wood" :max-height="200" :tabindex="2"
                       placeholder="Choose wood" label="name" track-by="id"
                       :options="wood" :multiple="false"
                       @select="selectHumidity"
                       :show-labels="false"
                       :disabled="!isActiveLot"
                       :class="{ required: (!lotData.wood || lotData.wood.length === 0) }"
                       :taggable="true" :close-on-select="true"></multiselect>
        </b-col>
        <b-col cols="2">
          <label>{{$t('labels.common.sum')}}</label>
        </b-col>
        <b-col cols="4">
          <input class="form-control" v-model="lotData.sum"
                 :disabled="true">
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="2">
          <label>{{$t('labels.common.thickness')}}</label>
        </b-col>
        <b-col cols="2">
          <input class="form-control" v-model="lotData.thickness_nominal_from" tabindex="3"
                 :class="{ required: (!lotData.thickness_nominal_from && lotData.thickness_nominal_from !== 0) }"
                 :disabled="!isActiveLot"
                 placeholder="from" v-replace-with-positive>
        </b-col>
        <b-col cols="2">
          <input class="form-control" v-model="lotData.thickness_nominal_to" tabindex="4"
                 placeholder="to" :disabled="!isActiveLot"
                 :class="{ required: (!lotData.thickness_nominal_to) }" v-replace-with-positive>
        </b-col>
        <b-col cols="2">
          <label>{{$t('labels.common.supplier')}}</label>
        </b-col>
        <b-col cols="4">
          <multiselect v-model="lotData.shipper" :max-height="200" :tabindex="13"
                       placeholder="Choose supplier" label="name" track-by="id"
                       :options="suppliers" :disabled="!isActiveLot"
                       :show-labels="false" :multiple="true"
                       :class="{ required: (!lotData.shipper || lotData.shipper.length === 0) }"
                       :taggable="true" :close-on-select="false"></multiselect>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="2">
          <label>{{$t('labels.common.width')}}</label>
        </b-col>
        <b-col cols="2">
          <input class="form-control" v-model="lotData.width_nominal_from" tabindex="5"
                 placeholder="from" :disabled="!isActiveLot"
                 :class="{ required: (!lotData.width_nominal_from && lotData.width_nominal_from !== 0) }"
                 v-replace-with-positive
          >
        </b-col>
        <b-col cols="2">
          <input class="form-control" v-model="lotData.width_nominal_to" tabindex="6"
                 :class="{ required: (!lotData.width_nominal_to) }"
                 :disabled="!isActiveLot"
                 placeholder="to" v-replace-with-positive>
        </b-col>
        <b-col cols="2">
          <label>{{$t('labels.common.delivery_date')}}</label>
        </b-col>
        <b-col cols="4">
          <datepicker v-model="lotData.delivery_term" lang="en" :tabindex="14"
                      :disabled="!isActiveLot" :first-day-of-week="1"
                      :class="{ required: (!lotData.delivery_term) }"
          ></datepicker>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="2">
          <label>{{$t('labels.common.length')}}</label>
        </b-col>
        <b-col cols="2">
          <input class="form-control" v-model="lotData.length_nominal_from" tabindex="7"
                 placeholder="from" :disabled="!isActiveLot"
                 :class="{ required: (!lotData.length_nominal_from && lotData.length_nominal_from !== 0) }"
                 v-replace-with-positive>
        </b-col>
        <b-col cols="2">
          <input class="form-control" v-model="lotData.length_nominal_to" tabindex="8"
                 placeholder="to" :disabled="!isActiveLot"
                 :class="{ required: (!lotData.length_nominal_to) }"
                 v-replace-with-positive>
        </b-col>
        <b-col cols="2">
          <label>{{$t('labels.common.transport')}}</label>
        </b-col>
        <b-col cols="4">
          <multiselect ref="transportSelect" v-model="lotData.delivery_method" :max-height="200" :tabindex="15"
                       placeholder="Choose transport" label="name" track-by="id"
                       :options="delivery_methods" :disabled="!isActiveLot"
                       :show-labels="false" :multiple="true"
                       :taggable="true" :close-on-select="false">
            <template slot="tag" slot-scope="props">
              <multiselect-tag-slot :props="props" :props-label="'name'"></multiselect-tag-slot>
            </template>
          </multiselect>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="2">
          <label>{{$t('labels.common.quality')}}</label>
        </b-col>
        <b-col cols="4">
          <multiselect v-model="lotData.quality" :max-height="200" :tabindex="9"
                       placeholder="Choose quality" label="name" track-by="id"
                       :options="qualities_list"
                       :class="{ required: (!lotData.quality || lotData.quality.length === 0) }"
                       :show-labels="false" :disabled="!isActiveLot"
                       :taggable="true" :close-on-select="true"></multiselect>
        </b-col>
        <b-col cols="2">
          <label>{{$t('labels.common.delivery_term')}}</label>
        </b-col>
        <b-col cols="4">
          <multiselect ref="incotermsSelect" v-model="lotData.incoterms" :max-height="200" :tabindex="16"
                       placeholder="Choose delivery term" label="code" track-by="id"
                       :options="incoterms" :disabled="!isActiveLot" :options-height="120"
                       :show-labels="false" :multiple="true"
                       :taggable="true" :close-on-select="false">
            <template slot="tag" slot-scope="props">
              <multiselect-tag-slot :props="props" :props-label="'code'"></multiselect-tag-slot>
            </template>
          </multiselect>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="2">
          <label>{{$t('labels.common.humidity')}}</label>
        </b-col>
        <b-col cols="4">
          <multiselect v-model="lotData.humidity" :max-height="200" :tabindex="10"
                       placeholder="Choose humidity"
                       :options="humidity_list"
                       :class="{ required: (!lotData.humidity) }"
                       :show-labels="false" :disabled="!isActiveLot"
                       :taggable="true"></multiselect>
        </b-col>
        <b-col cols="2">
          <label>{{$t('labels.common.payment_terms')}}</label>
        </b-col>
        <b-col cols="4">
          <input class="form-control" v-model="lotData.payment_term" tabindex="17"
                 :disabled="!isActiveLot"
                 placeholder="terms">
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="2">
          <label>{{$t('labels.common.purchased')}}</label>
        </b-col>
        <b-col cols="2">
          <input class="form-control" v-model="lotData.amount" tabindex="11"
                 :class="{ required: (!lotData.amount) }"
                 :disabled="!isActiveLot"
                 v-digits-after-decimal="{numberOfDigits: 3}">
        </b-col>
        <b-col cols="2">
          <input class="form-control" value="m3" :disabled="true">
        </b-col>
        <b-col cols="2">
          <label>{{$t('labels.common.notes')}}</label>
        </b-col>
        <b-col cols="4">
          <b-form-textarea v-model="lotData.notes" placeholder="Enter notes" :disabled="!isActiveLot" :tabindex="18">
          </b-form-textarea>
        </b-col>
      </b-row>
      <div slot="modal-footer" class="w-100 text-right">
        <b-btn size="sm" variant="success" @click="saveLot('save')" :disabled="!isActiveLot">
          {{$t('buttons.common.save')}}
        </b-btn>
        <b-btn size="sm" variant="success" @click="saveLot('add_another')" :disabled="!this.lotData.isNewLot">
          {{$t('buttons.common.save_add_more')}}
        </b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import Multiselect from 'vue-multiselect';
  import Datepicker from 'vue2-datepicker';
  import { mapState } from 'vuex';
  import moment from 'moment';
  import multiselectTagSlot from '@/components/common/multiselectTagSlot';
  import {
    getArrayByProperty,
    handlerResponse,
    setNotifyData
  } from '@/helpers/commonHelpers';
  import { notificationsRenderer } from '@/helpers/renderHelpers';
  import { DATE_FORMAT } from '@/constants';

  export default {
    props: ['contract', 'isExchangeContract', 'selectedLot'],
    components: {
      Multiselect,
      Datepicker,
      multiselectTagSlot
    },
    data() {
      return {
        humidity: [],
        lotData: {
          isNewLot: true,
          contract: '',
          lot_nr: '',
          price_per_unit: '',
          currency: '',
          wood: '',
          sum: '',
          shipper: '',
          thickness_nominal_from: '',
          thickness_nominal_to: '',
          width_nominal_from: '',
          width_nominal_to: '',
          length_nominal_from: '',
          length_nominal_to: '',
          delivery_term: '',
          delivery_method: '',
          quality: '',
          incoterms: '',
          humidity: '',
          payment_term: '',
          amount: '',
          notes: '',
          status: 'active'
        },
        lotDataInitial: {}
      }
    },
    methods: {
      async loadSettings() {
        this.$store.dispatch('partners/getSuppliers');
        this.$store.dispatch('woodware/loadHumidityList');
        await this.$store.cache.dispatch('woodware/getWood');
        await this.$store.cache.dispatch('generic/loadIncoterms');
        await this.$store.cache.dispatch('woodware/getDeliveryMethods');
        await this.$store.dispatch('woodware/getQualitiesList');
        this.setDefaults();
      },
      setDefaults() {
        //set Wood Pusis
        this.lotData.wood = this.wood.find(e => e.id === 2);
        //set incoterms FCA
        this.lotData.incoterms = this.incoterms.filter(e => e.id === 4);
        // set delivery method truck
        this.lotData.delivery_method = this.delivery_methods.filter(e => e.id === 2);
        //set quality 1-3
        this.lotData.quality = this.qualities_list.find(e => e.id === 19);
        this.lotDataInitial = {...this.lotData};
      },
      saveLot(event) {
        const saveData = {
          ...this.lotData,
          contract: this.lotData.isNewLot ? this.contract : this.lotData.contract.id,
          wood: this.lotData.wood ? this.lotData.wood.id : '',
          quality: this.lotData.quality ? this.lotData.quality.id : '',
          incoterms: this.lotData.incoterms ? getArrayByProperty(this.lotData.incoterms, 'id') : [],
          delivery_term: this.lotData.delivery_term ? moment(this.lotData.delivery_term).format(DATE_FORMAT) : '',
          shipper: this.lotData.shipper ? getArrayByProperty(this.lotData.shipper, 'id') : [],
          delivery_method: this.lotData.delivery_method ? getArrayByProperty(this.lotData.delivery_method, 'id') : []
        };
        if (this.checkTWL()) {
          if (this.lotData.isNewLot) {
            this.$http.post(`purchase/lots/`, {...saveData, status: 'active'})
              .then(handlerResponse).then((response) => {
              this.$notify(setNotifyData('Success', 'Lot has been created!', 'success'));
              this.$store.dispatch('lots/loadLots', {contract_id: saveData.contract});
              this.$root.$emit('updatePurchaseContractInfo', {id: saveData.contract});
              if (event === 'add_another') {
                this.lotData = {...this.lotDataInitial};
                this.setDefaults();
              } else {
                this.$refs['createLotModal'].hide();
              }
            }).catch((error) => {
              console.log(error);
              notificationsRenderer(error.body, 'error');
            })
          } else {
            this.$http.put(`purchase/lots/${this.lotData.id}/`, saveData).then(handlerResponse).then(() => {
              this.$notify(setNotifyData('Success', 'Lot has been edited!', 'success'));
              this.$store.dispatch('lots/loadLots', {contract_id: saveData.contract});
              this.$root.$emit('updatePurchaseContractInfo', {id: saveData.contract});
              this.$refs['createLotModal'].hide();
            }).catch((error) => {
              console.log(error);
              notificationsRenderer(error.body, 'error');
            });
          }
        }
      },
      getSum() {
        if (this.lotData.price_per_unit && this.lotData.amount) {
          this.lotData.sum = (this.lotData.price_per_unit * this.lotData.amount).toFixed(2);
        } else {
          this.lotData.sum = ''
        }
      },
      selectHumidity(event) {
        this.humidity = event.humidity_list;
      },
      checkTWL() {
        if (Number(this.lotData.thickness_nominal_from) > Number(this.lotData.thickness_nominal_to)) {
          this.$notify(setNotifyData('', 'Minimum thickness could not be greater then maximum', 'error'));
          return false
        } else if (Number(this.lotData.width_nominal_from) > Number(this.lotData.width_nominal_to)) {
          this.$notify(setNotifyData('', 'Minimum width could not be greater then maximum', 'error'));
          return false
        } else if (Number(this.lotData.length_nominal_from) > Number(this.lotData.length_nominal_to)) {
          this.$notify(setNotifyData('', 'Minimum length could not be greater then maximum', 'error'));
          return false
        } else {
          return true
        }
      }
    },
    async beforeMount() {
      await this.loadSettings();
      this.setDefaults();
    },
    mounted() {
      this.$root.$on('openLotModal', (selectedLot) => {
        if (this.$refs['createLotModal']) {
          this.lotData = {...selectedLot};
          if (selectedLot.isNewLot) {
            this.setDefaults();
          }
          this.lotDataInitial = {
            ...this.lotDataInitial,
            currency: selectedLot.currency,
            isNewLot: selectedLot.isNewLot
          };
          this.getSum();
          this.$refs['createLotModal'].show();
        }
      })
    },
    beforeDestroy() {
      this.$root.$off('openLotModal');
    },
    computed: {
      ...mapState('woodware', ['wood', 'humidity_list', 'delivery_methods', 'qualities_list']),
      ...mapState('partners', ['suppliers']),
      ...mapState('generic', ['incoterms']),
      isActiveLot() {
        return this.lotData.status === 'active' || this.lotData.isNewLot
      },
      title() {
        return this.lotData.isNewLot && this.isExchangeContract ? `${this.$i18n.t('modal_dialogs.purchase_lots.add_lot')}` :
          !this.lotData.isNewLot && this.isExchangeContract ? `${this.$i18n.t('modal_dialogs.purchase_lots.edit_lot')}` :
            this.lotData.isNewLot && !this.isExchangeContract ? `${this.$i18n.t('modal_dialogs.purchase_lots.add_specification')}` :
              !this.lotData.isNewLot && !this.isExchangeContract ? `${this.$i18n.t('modal_dialogs.purchase_lots.edit_specification')}` : ''
      }
    },
    watch: {
      'lotData.amount'() {
        this.getSum();
      },
      'lotData.price_per_unit'() {
        this.getSum();
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/modals/PurchaseLotModal.vue